import * as React from 'react';
import classNames from 'classnames';
import './Tab.scss';
import { useState } from 'react';

export interface TabPane {
    title: string;
    render: React.ReactNode;
}

export interface TabProps {
    className?: string;
    panes: TabPane[];
}

export default function Tab(props: TabProps) {
    const { className, panes } = props;

    const cssClasses = classNames('tab', className);
    const [activeIndex, setActiveIndex] = useState(0);

    const onClickButton = (nextActiveIndex: number) =>
        setActiveIndex(nextActiveIndex);
    return (
        <div className={cssClasses}>
            <div className="tab-buttons">
                {panes.map((p, i) => (
                    <div
                        key={p.title}
                        className={classNames(
                            'tab-button',
                            i === activeIndex && 'active'
                        )}
                        onClick={() => onClickButton(i)}
                    >
                        {p.title}
                    </div>
                ))}
            </div>
            <div className="tab-panels">
                {panes.map((p, i) => (
                    <div
                        key={p.title}
                        className={classNames(
                            'tab-panel',
                            i === activeIndex && 'active'
                        )}
                    >
                        {p.render}
                    </div>
                ))}
            </div>
        </div>
    );
}
